export default // 多边形
class Polygon {
  constructor ({ sandbox, points, color, zIndex, shape_type }) {
    this.sandbox = sandbox
    this.ctx = sandbox.ctx
    this.entityType = 'polygon'  // polygon
    this.points = [...points]
    this.color = color || '#fff'
    this.zIndex = zIndex || 0
    this.id = this.sandbox.getEntityId()
    this.visible = true
    this.judgeBy = 'points'
    this.custom = {},
    this.shape_type = shape_type
  }

  render () {
    if (!this.points.length) return
    this.ctx.save()
    this.ctx.fillStyle = this.color
    this.ctx.lineWidth = 5
    this.ctx.strokeStyle = '#90EE90'
    this.ctx.beginPath()
    if(this.shape_type === 'circle'){
      var radius = Math.sqrt(Math.pow(Math.abs(this.points[1][0] - this.points[0][0]),2)+Math.pow(Math.abs(this.points[1][1] - this.points[0][1]),2));
      this.ctx.arc(this.points[0][0], this.points[0][1], radius, 0, 2 * Math.PI, true)
    }else if (this.shape_type === 'rectangle'){
      this.ctx.rect(this.points[0][0], this.points[0][1],
        this.points[1][0] - this.points[0][0],
        this.points[1][1] - this.points[0][1])
    }else if (this.shape_type === 'line' || this.shape_type === 'linestrip' || this.shape_type === 'point'){
      this.ctx.moveTo(...this.points[0])
      for (let i = 1; i < this.points.length; i++) {
        const arr = this.points[i]
        if (arr.length === 2) {
          this.ctx.lineTo(...arr)
        }
      }
    }else{

      this.ctx.moveTo(...this.points[0])
      for (let i = 1; i < this.points.length; i++) {
        const arr = this.points[i]
        if (arr.length === 2) {
          this.ctx.lineTo(...arr)
        }
      }
      this.ctx.closePath()
    }
    this.ctx.stroke()
    this.ctx.restore()
    
  }

  destruct () {
    this.sandbox.remove(this)
  }

  on (type, callback, option = {}) {
    const eventMap = this.sandbox.eventMap[type]
    if (eventMap) {
      if (!eventMap.has(this.id)) {
        eventMap.set(this.id, [])
      }
      const callbackSet = eventMap.get(this.id)
      callbackSet.push({
        handler: callback,
        option: option
      })
    } else {
      console.error('事件类型有误')
    }
  }

  off (type, callback) {
    const eventMap = this.sandbox.eventMap[type]
    if (eventMap) {
      const callbackSet = eventMap.get(this.id)
      if (callbackSet) {
        const index = callbackSet.findIndex(i => i.handler === callback)
        if (index !== -1) {
          callbackSet.splice(index, 1)
        }
      }
    } else {
      console.error('事件类型有误')
    }
  }
}
